import { render, staticRenderFns } from "./LvQuestion.vue?vue&type=template&id=321fb56f"
import script from "./LvQuestion.vue?vue&type=script&lang=js"
export * from "./LvQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports